import React, { useState } from "react";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { Button, FormControl, InputGroup, Row } from "react-bootstrap";
import { ApiHelper, ToastHelper } from "../../helpers";

interface Props {
  onSelect: (img: string) => void,
  onStockSelect: (img: string) => void
}

interface SearchResult { description: string, url: string, photographer: string, photographerUrl: string, large: string, thumbnail: string }

export const StockPhotos: React.FC<Props> = (props: Props) => {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState<SearchResult[]>(null);

  const handleSearch = (e: React.MouseEvent) => {
    if (e !== null) e.preventDefault();
    let term = searchText.trim();
    ApiHelper.post<SearchResult[]>("/stock/search", { term: term })
      .then((data) => { setSearchResults(data || []) })
      .catch(err => {
        console.error("Failed to search stock photos:", err);
        ToastHelper.error("Failed to search stock photos");
      });
  }

  const getImages = () => {
    if (searchResults) return getResults();
    else return <p style={{ paddingLeft:15 }}>Search for stock photos</p>
  }

  const getResults = () => {
    let result: React.ReactElement[] = [];
    searchResults.forEach(p => {
      result.push(<Col md={2} xs={12} style={{paddingBottom:20}}>
        <a href="about:blank" onClick={(e) => { e.preventDefault(); props.onStockSelect(p.large) }}>
          <img src={p.thumbnail} className="img-fluid" alt="stock" />
        </a>
        <div>
          <i style={{ fontSize: 12 }}>
            <a href={p.url} target="_blank" rel="noreferrer noopener">Photo</a> by: <a href={p.photographerUrl} target="_blank" rel="noreferrer noopener">{p.photographer}</a></i>
        </div>
      </Col>);
    })
    return result;
  }

  return (<>
    <div style={{display:"block", flex:1, paddingRight:40, textAlign:"left" }}>
      <FormGroup className="mb-3">
        <FormLabel>Search Term</FormLabel>
        <InputGroup>
          <FormControl data-testid="stock-search-input" id="term" value={searchText} onChange={(e) => { e.preventDefault(); setSearchText(e.currentTarget.value) }} />
          <Button data-testid="stock-search-button" variant="primary" onClick={handleSearch}>Search</Button>
        </InputGroup>
      </FormGroup>
      {searchResults && <div>Stock photos provided by <a href="https://pexels.com">Pexels</a>.</div>}
      <Row>
        {getImages()}
      </Row>
    </div>
  </>);
};
